import * as React from "react";
import { FC } from "react";
import { Feature } from "ol";
import { IUpdates } from "../Map/mapProvider";
import { DemoAttributeTable } from "./DemoAttributeTable";
import { Collapsible } from "./Collapsible";

export interface IDemoFeatures {
  filteredObjects: Feature[];
  identifiedObject: Feature;
  onZoomToGraphic: (graphic: Feature) => void;
  onUpdateAttributes: (graphic: Feature, updates: IUpdates) => void;
}

export const DemoFeatures: FC<IDemoFeatures> = (props: IDemoFeatures) => {
  return (
    <Collapsible title="Objekti, objekta atribūti" defaultCollapsed={true}>
      <FeatureList
        filteredObjects={props.filteredObjects}
        onZoomToGraphic={props.onZoomToGraphic}
        onUpdateAttributes={props.onUpdateAttributes}
      ></FeatureList>
      <FeatureAttributes
        identifiedObject={props.identifiedObject}
        onZoomToGraphic={props.onZoomToGraphic}
        onUpdateAttributes={props.onUpdateAttributes}
      ></FeatureAttributes>
    </Collapsible>
  );
};

const FeatureList = ({
  filteredObjects,
  onZoomToGraphic,
  onUpdateAttributes,
}: {
  filteredObjects: Feature[];
  onZoomToGraphic: (graphic: Feature) => void;
  onUpdateAttributes: (graphic: Feature, updates: IUpdates) => void;
}) => {
  const featuresCount = filteredObjects ? filteredObjects.length : 0;
  return (
    <div className="list features">
      <div className="list-title">{featuresCount + " objekti"}</div>
      {filteredObjects &&
        filteredObjects.map((object, i) => (
          <div
            className="feature"
            //@ts-ignore
            key={i + "-" + object.values_.OBJECTID}
            style={{ border: "1px solid red" }}
          >
            <DemoAttributeTable
              graphic={object}
              onZoomToGraphic={onZoomToGraphic}
              onUpdateAttributes={onUpdateAttributes}
            />
          </div>
        ))}
    </div>
  );
};

const FeatureAttributes = ({
  identifiedObject,
  onZoomToGraphic,
  onUpdateAttributes,
}: {
  identifiedObject: Feature;
  onZoomToGraphic: (graphic: Feature) => void;
  onUpdateAttributes: (graphic: Feature, updates: IUpdates) => void;
}) => {
  return (
    <div className="list attributes">
      <div className="list-title">Uzklikots:</div>
      {identifiedObject && (
        //@ts-ignore
        <div className="feature" key={"f" + identifiedObject.values_.OBJECTID}>
          <DemoAttributeTable
            onZoomToGraphic={onZoomToGraphic}
            graphic={identifiedObject}
            onUpdateAttributes={onUpdateAttributes}
          />
        </div>
      )}
    </div>
  );
};
